import React from 'react';
import { useNavigate } from 'react-router-dom';

const TeamDisplay = ({ team, title, colorClass, isAdmin }) => {
    const navigate = useNavigate();

    if (!team) return null;

    const getPlayerPositions = () => {
        const positions = {
            'defense': { y: 70 },
            'midfield': { y: 42 },
            'attack': { y: 15 }
        };

        let allPlayers = [];
        ['defense', 'midfield', 'attack'].forEach((section, sectionIndex) => {
            if (team[section] && team[section].length > 0) {
                team[section].forEach((player, playerIndex) => {
                    const totalPlayers = team[section].length;
                    const xSpacing = 100 / (totalPlayers + 1);
                    const x = xSpacing * (playerIndex + 1);
                    
                    allPlayers.push({
                        ...player,
                        x,
                        y: positions[section].y
                    });
                });
            }
        });

        return allPlayers;
    };

    return (
        <div className={`team-section ${colorClass}`}>
            <h3>{title}</h3>
            {isAdmin === 'true' && (
                <div className="team-ratings">
                    <div className="ratings">
                        <div className="rating overall">
                            <span className="label">Overall</span>
                            <span className="value">
                                {(team.team_ratings?.overall || team.average_skill)
                                    ? Number(team.team_ratings?.overall || team.average_skill).toFixed(1)
                                    : '-'}
                            </span>
                        </div>
                        <div className="rating-group">
                            <div className="rating">
                                <span className="label">Attack</span>
                                <span className="value">
                                    {(team.team_ratings?.attack || team.attack_rating)
                                        ? Number(team.team_ratings?.attack || team.attack_rating).toFixed(1)
                                        : '-'}
                                </span>
                            </div>
                            <div className="rating">
                                <span className="label">Midfield</span>
                                <span className="value">
                                    {(team.team_ratings?.midfield || team.midfield_rating)
                                        ? Number(team.team_ratings?.midfield || team.midfield_rating).toFixed(1)
                                        : '-'}
                                </span>
                            </div>
                            <div className="rating">
                                <span className="label">Defense</span>
                                <span className="value">
                                    {(team.team_ratings?.defense || team.defense_rating)
                                        ? Number(team.team_ratings?.defense || team.defense_rating).toFixed(1)
                                        : '-'}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className="formation-section">
                <div className="formation">Formation: {team.formation || 'TBD'}</div>
                {team.formation_explanation && (
                    <div className="formation-explanation">
                        {team.formation_explanation}
                    </div>
                )}
            </div>
            
            {team.team_strategy && (
                <div className="team-strategy">
                    <h4>Team Strategy</h4>
                    <p>{team.team_strategy}</p>
                </div>
            )}

            {/* <div className="team-stats">
                <div className="stat-box">
                    <div className="stat-label">Average FW Rating</div>
                    <div className="stat-value">{team.average_skill || '-'}</div>
                </div>
                <div className="stat-box">
                    <div className="stat-label">Attack<br/>Rating</div>
                    <div className="stat-value">{team.attack_rating || '-'}</div>
                </div>
                <div className="stat-box">
                    <div className="stat-label">Defense<br/>Rating</div>
                    <div className="stat-value">{team.defense_rating || '-'}</div>
                </div>
            </div> */}

            <div className="formation-visualization">
                <h4>Formation</h4>
                <div className="formation-display">
                    <div className="pitch">
                        {getPlayerPositions().map((player, index) => (
                            <div
                                key={player.player_id}
                                className="formation-player"
                                style={{
                                    left: `${player.x}%`,
                                    top: `${player.y}%`
                                }}
                            >
                                <div className="player-dot">
                                    {player.player_id}
                                </div>
                                <div className="player-name">
                                    {player.name.split(' ')[0]}<br/>
                                    {player.name.split(' ')[1]}
                                    {/* <span>{player.playing_role}</span> */}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="players-grid">
                {['defense', 'midfield', 'attack'].map((section) => (
                    team[section] && team[section].length > 0 && (
                        
                        <div key={section} className="team-line">
                            <h4>{section.charAt(0).toUpperCase() + section.slice(1)}</h4>
                            <div className="player-card">
                                {team[section].map((player) => [
                                    <div key={`info-${player.player_id}`} className="player-info">
                                        <div className="player-name">{player.player_id}. {player.name}</div>
                                        <div className="player-position">{player.playing_role}</div>
                                    </div>,
                                    
                                    isAdmin === 'true' && (
                                        <>
                                        <div key={`stats-${player.player_id}`} className="player-stats">
                                            <div>FW: <span>{player.skill_rating}</span></div>
                                            <div>Form: <span>{player.form_rating}/10</span></div>
                                            {player.recent_goals > 0 && (
                                                <div>Goals (Last 5 games): <span>{player.recent_goals}</span></div>
                                            )}
                                        </div>
                                            {player.player_analysis && (
                                                <div className="player-analysis">
                                                    {player.player_analysis}
                                                </div>
                                            )}
                                        </>
                                    )
                                ])}
                            </div>
                        </div>
                    )
                ))}
            </div>
        </div>
    );
};

export default TeamDisplay; 